import React from 'react';
import { AppsGridBox } from '../apps-grid-box';
import { SubHeader } from '../sub-header';
import { composer } from '../../../../component-decorators/composer';
export const UninstalledAppsGrid = composer()
    .withTranslation()
    .compose(({ t, solutions, finalColumns, onClick, onInstalledAppClick, showViewAppButton, showDeveloperName, showRating, showPricing, showTopBadge, skin, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(SubHeader, { title: t('solutionBox.gridBoxUninstalledApps.title') }),
        React.createElement(AppsGridBox, { showTopBadge: showTopBadge, skin: skin, finalColumns: finalColumns, showDeveloperName: showDeveloperName, showRating: showRating, showPricing: showPricing, showViewAppButton: showViewAppButton, solutions: solutions, onClick: onClick, onInstalledAppClick: onInstalledAppClick })));
});
//# sourceMappingURL=UninstalledAppsGrid.js.map